"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuarterHourMonthBasedArrayDef = exports.QuarterHourYearBasedArrayDef = exports.HourlyYearBasedArrayDef = exports.DailyDecadeBasedArrayDef = void 0;
exports.DailyDecadeBasedArrayDef = [10, 12, 31];
exports.HourlyYearBasedArrayDef = [12, 31, 24];
exports.QuarterHourYearBasedArrayDef = [12, 31, 24, 4];
exports.QuarterHourMonthBasedArrayDef = [31, 24, 4];
